export const space = {
  "2xl": 24,
  "2xs": 4,
  "3xl": 32,
  "3xs": 2,
  "4xl": 40,
  "5xl": 56,
  card: {
    gap: 16,
    inset: 12,
  },
  lg: 16,
  md: 12,
  screen: {
    inset: 16,
  },
  section: {
    gap: 24,
  },
  sm: 8,
  xl: 20,
  xs: 6,
} as const;

export type Space = typeof space;

export const radius = {
  chip: 4,
  full: 9999,
  lg: 16,
  md: 12,
  none: 0,
  sm: 8,
  xl: 24,
  xs: 4,
} as const;

export type Radius = typeof radius;
